import type IProduct from "@api/models/IProduct";
import AccountDisplay from "@core-components/accountDisplay/AccountDisplay";
import SSProductCard from "@core-components/product/component/SSProductCard";
import SSLoLGradientText from "@core-components/title/components/SSLoLGradientText";
import SSWhiteText from "@core-components/title/components/SSWhiteText";
import useAppTranslation from "@hooks/language/useAppTranslation";
import { Trans } from "react-i18next";

interface SmurfsNormalProductListProps {
  products: IProduct[];
}

export const SmurfsNormalProductList = ({
  products,
}: SmurfsNormalProductListProps) => {
  const { t } = useAppTranslation("pages.normal");

  return (
    <AccountDisplay.List
      emoji="Fire"
      label={
        <Trans i18nKey="list.title" t={t}>
          <SSWhiteText>NOS COMPTES</SSWhiteText>
          <SSLoLGradientText>SMURFS LOL</SSLoLGradientText>
          <SSWhiteText>ENGLISH LABEL</SSWhiteText>
        </Trans>
      }
    >
      {products.map((product) => (
        <SSProductCard
          key={product.i18nKey}
          product={product}
          header={t("list.productCardHeader")}
        />
      ))}
    </AccountDisplay.List>
  );
};
